import classNames from 'classnames';

import useStyles from './styles';

function IconBlockWithCTAsFallback() {
  const styles = useStyles();

  return (
    <div className={classNames(styles.root, styles.skeleton)}>
      <span className={classNames(styles.skeletonTitle, 'skeleton')} />
      <div className={styles.skeletonContent}>
        {[...Array(5)].map((item, index) => (
          <span
            className={classNames(styles.skeletonCard, 'skeleton')}
            key={`IconBlockWithCTAsFallback-${item}-${index}`}
          />
        ))}
      </div>
      <span className={classNames(styles.skeletonButton, 'skeleton')} />
    </div>
  );
}

export default IconBlockWithCTAsFallback;
